namespace GeniuzPOS.Purchase {
    export interface PoBankRow {
        Id?: number;
        BankId?: string;
        BankName?: string;
        BankAccount?: string;
        BankShortName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PoBankRow {
        export const idProperty = 'BankId';
        export const nameProperty = 'BankName';
        export const localTextPrefix = 'Purchase.PoBank';
        export const lookupKey = 'Purchase.PoBank';

        export function getLookup(): Q.Lookup<PoBankRow> {
            return Q.getLookup<PoBankRow>('Purchase.PoBank');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            BankId = "BankId",
            BankName = "BankName",
            BankAccount = "BankAccount",
            BankShortName = "BankShortName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
